export const WroStatusesEnum = {
  Unknown: 'wroStatuses.Unknown',
  AwaitingArrival: 'wroStatuses.AwaitingArrival',
  Processing: 'wroStatuses.Processing',
  Received: 'wroStatuses.Received',
  Cancelled: 'wroStatuses.Cancelled',
  Draft: 'wroStatuses.Draft',
  Arrived: 'wroStatuses.Arrived',
  PartiallyArrived: 'wroStatuses.PartiallyArrived',
  PartiallyArrivedAtHub: 'wroStatuses.PartiallyArrivedAtHub',
  ArrivedAtHub: 'wroStatuses.ArrivedAtHub',
  ProcessingAtHub: 'wroStatuses.ProcessingAtHub',
  InternalTransfer: 'wroStatuses.InternalTransfer'
}

export const WroBoxStatusesEnum = {
  Unknown: 'wroBoxStatuses.Unknown',
  Awaiting: 'wroBoxStatuses.Awaiting',
  Arrived: 'wroBoxStatuses.Arrived',
  Completed: 'wroBoxStatuses.Completed',
  Counting: 'wroBoxStatuses.Counting',
  Stowing: 'wroBoxStatuses.Stowing',
  Cancelled: 'wroBoxStatuses.Cancelled',
  InternalTransfer: 'wroBoxStatuses.InternalTransfer'
}

export const WroSendOptionsEnum = {
  Unknown: 'wroSendOptions.Unknown',
  SendOnOwn: 'wroSendOptions.SendOnOwn',
  GetPrepaidShippingLabels: 'wroSendOptions.GetPrepaidShippingLabels'
}

export const WroPackageTypesEnum = {
  Unknown: 'wroPackageTypes.Unknown',
  Box: 'wroPackageTypes.Box',
  Pallet: 'wroPackageTypes.Pallet',
  FloorLoadedContainer: 'wroPackageTypes.FloorLoadedContainer'
}

export const WroBoxConfigurationEnum = {
  Unknown: 'wroBoxConfigurations.Unknown',
  OneSkuPerBox: 'wroBoxConfigurations.OneSkuPerBox',
  MultipleSkuPerBox: 'wroBoxConfigurations.MultipleSkuPerBox'
}

export const WroColumnNamesEnum = {
  Id: 'wroColumnNames.Id',
  PurchaseOrderNumber: 'wroColumnNames.PurchaseOrderNumber',
  CreationDate: 'wroColumnNames.CreationDate',
  FulfillmentCenter: 'wroColumnNames.FulfillmentCenter',
  WroSummary: 'wroColumnNames.WroSummary',
  ReturnId: 'wroColumnNames.ReturnId',
  LastUpdatedDate: 'wroColumnNames.LastUpdatedDate',
  Status: 'wroColumnNames.Status'
}

export const WroFilterEnum = {
  HideReturns: 'wroFilters.HideReturns',
  AwaitingArrival: 'wroFilters.AwaitingArrival',
  Processing: 'wroFilters.Processing',
  Received: 'wroFilters.Received',
  Cancelled: 'wroFilters.Cancelled',
  Draft: 'wroFilters.Draft',
  Arrived: 'wroFilters.Arrived',
  PartiallyArrived: 'wroFilters.PartiallyArrived',
  NoCancelled: 'wroFilters.NoCancelled',
  OnlyReturns: 'wroFilters.OnlyReturns',
  WroId: 'wroFilters.WroId',
  FulfillmentCenter: 'wroFilters.FulfillmentCenter',
  Product: 'wroFilters.Product',
  Hub: 'wroFilters.Hub',
  InternalTransfer: 'wroFilters.InternalTransfer',
  DestinationFC: 'wroFilters.DestinationFC'
}

export const WroBoxSlaEnum = {
  Unknown: 'wroBoxSla.Unknown',
  Pending: 'wroBoxSla.Pending',
  OnTime: 'wroBoxSla.OnTime',
  Late: 'wroBoxSla.Late',
  Delayed: 'wroBoxSla.Delayed'
}

export const WroSlaStatusEnum = {
  Unknown: 'wroSlaStatus.Unknown',
  Pending: 'wroSlaStatus.Pending',
  OnTime: 'wroSlaStatus.OnTime',
  Late: 'wroSlaStatus.Late'
}
